import { defineMessages } from 'react-intl';

export const registrationMessages = defineMessages({
    'registration.heading': {
        id: 'registration.heading',
        defaultMessage: 'Registration',
        description: 'Title for the registration section.',
    },
    'registration.skip_access_code': {
        id: 'registration.skip_access_code',
        defaultMessage: 'Skip Access Code',
        description: 'Button to skip entering an access code.',
    },
    'registration.skip_eligibility': {
        id: 'registration.skip_eligibility',
        defaultMessage: 'Skip Eligibility',
        description: 'Button to skip verifying eligibility.',
    },
    'registration.get_started': {
        id: 'registration.get_started',
        defaultMessage: "Let's Get Started",
        description: 'Prompt to start the registration process.',
    },
    'registration.sponsor_label': {
        id: 'registration.sponsor_label',
        defaultMessage: 'Your Calm Health Sponsor',
        description: 'Label for the sponsor of a user’s subscription',
    },
    'registration.tos_step.header': {
        id: 'registration.tos_step.header',
        defaultMessage: 'Registration',
        description: 'Header for the registration section.',
    },
    'registration.tos_step.titleV2': {
        id: 'registration.tos_step.titleV2',
        defaultMessage: 'Accept Terms of Service and Privacy Policy',
        description: 'Title asking the user to accept the terms of service.',
    },
    'registration.tos_step.subtitleV2': {
        id: 'registration.tos_step.subtitleV2',
        defaultMessage:
            'Please enter your name so we know how to refer to you on your journey.',
        description: 'Prompt to enter the user’s name.',
    },
    'registration.tos_step.by_continuingV2': {
        id: 'registration.tos_step.by_continuingV2',
        defaultMessage:
            'By continuing you acknowledge that Calm Health is a mental health wellness product. Calm Health is not intended to diagnose or treat depression, anxiety, or any other mental or physical condition. Calm Health is not a substitute for a healthcare provider. Any questions that you may have about the diagnosis, care, or treatment of a medical condition should be directed to a healthcare provider. Individuals under the age of 13 are not permitted to use Calm Health.',
        description: 'Terms of service for Calm Health and a disclaimer.',
    },
    'registration.tos_step.fields.givenName.label': {
        id: 'registration.tos_step.fields.givenName.label',
        defaultMessage: 'First Name (Required)',
        description: 'Label for the input field for the user’s first name.',
    },
    'registration.tos_step.fields.givenName.error.required': {
        id: 'registration.tos_step.fields.givenName.error.required',
        defaultMessage: 'Error: Provide a first name to continue',
        description:
            'Error message when the user does not provide a first name.',
    },
    'registration.tos_step.fields.familyName.label': {
        id: 'registration.tos_step.fields.familyName.label',
        defaultMessage: 'Last Name',
        description: 'Label for the input field for the user’s last name.',
    },
    'registration.tos_step.fields.email.label': {
        id: 'registration.tos_step.fields.email.label',
        defaultMessage: 'Email (Required)',
        description: 'Label for the input field for the user’s email address.',
    },
    'registration.tos_step.fields.email.error.valid': {
        id: 'registration.tos_step.fields.email.error.valid',
        defaultMessage: 'Error: Provide a valid email address to continue',
        description:
            'Error message when the user does not provide a valid email address.',
    },
    'registration.tos_step.fields.hasAgreedTerms.label': {
        id: 'registration.tos_step.fields.hasAgreedTerms.label',
        defaultMessage: 'I agree to the Terms of Service and Privacy Policy',
        description: 'Label for the checkbox to accept the terms of service.',
    },
    'registration.tos_step.fields.hasAgreedTerms.labelV2': {
        id: 'registration.tos_step.fields.hasAgreedTerms.labelV2',
        defaultMessage: 'You agree to the Terms of Service and Privacy Policy',
        description: 'Label for the checkbox to accept the terms of service.',
    },
    'registration.tos_step.fields.hasAgreedTerms.error.required': {
        id: 'registration.tos_step.fields.hasAgreedTerms.error.required',
        defaultMessage:
            'Error: You must agree to the Terms of Service and Privacy Policy to continue',
        description:
            'Error message when the user does not accept the terms of service.',
    },
    'registration.access_code_step.header': {
        id: 'registration.access_code_step.header',
        defaultMessage: 'Access Code',
        description: 'Header for the access code section.',
    },
    'registration.access_code_step.title': {
        id: 'registration.access_code_step.title',
        defaultMessage: 'Enter your access code',
        description: 'Title for the access code section.',
    },
    'registration.access_code_step.subtitle': {
        id: 'registration.access_code_step.subtitle',
        defaultMessage:
            'Access to Calm Health is sponsored by your employer, healthcare provider, or health insurance plan.',
        description: 'Explanation of the access code section.',
    },
    'registration.access_code_step.fields.accessCode.label': {
        id: 'registration.access_code_step.fields.accessCode.label',
        defaultMessage: 'Access Code',
        description: 'Label for the input field for the user’s access code.',
    },
    'registration.access_code_step.fields.accessCode.label-v2': {
        id: 'registration.access_code_step.fields.accessCode.label-v2',
        defaultMessage: 'Access Code (Required)',
        description: 'Label for the input field for the user’s access code.',
    },
    'registration.access_code_step.fields.accessCode.error.required': {
        id: 'registration.access_code_step.fields.accessCode.error.required',
        defaultMessage: 'Error: Enter a valid access code',
        description:
            'Error message when the user does not provide an access code.',
    },
    'registration.access_code_step.fields.accessCode.error.existing': {
        id: 'registration.access_code_step.fields.accessCode.error.existing',
        defaultMessage:
            'Error: This access code is linked to your existing sponsorship',
        description:
            'Error message when the user tries to use an access code that is already linked to their account.',
    },
    'registration.access_code_step.dontHaveAccessCode': {
        id: 'registration.access_code_step.dontHaveAccessCode',
        defaultMessage: "Don't Have An Access Code?",
        description:
            'Title for the section that explains how to get an access code.',
    },
    'registration.partner_authorization_step.accept': {
        id: 'registration.partner_authorization_step.accept',
        defaultMessage: 'I Accept',
        description: 'Button to accept the partner authorization.',
    },
    'registration.partner_authorization_step.header': {
        id: 'registration.partner_authorization_step.header',
        defaultMessage: 'Authorization',
        description: 'Header for the partner authorization section.',
    },
    'registration.partner_authorization_step.consent.title': {
        id: 'registration.partner_authorization_step.consent.title',
        defaultMessage: 'Partner Consent',
        description: 'Title for the partner consent section.',
    },
    'registration.eligibility_step.heading': {
        id: 'registration.eligibility_step.heading',
        defaultMessage: 'Eligibility',
        description: 'Header for the eligibility section.',
    },
    'registration.eligibility_step.title': {
        id: 'registration.eligibility_step.title',
        defaultMessage: 'Check your eligibility',
        description: 'Title for the screen verifying eligibility.',
    },
    'registration.eligibility_step.not_your_employer': {
        id: 'registration.eligibility_step.not_your_employer',
        defaultMessage: 'Have a different access code?',
        description: 'Button to update the sponsor.',
    },
    'registration.eligibility_step.eligibility_denied': {
        id: 'registration.eligibility_step.eligibility_denied',
        defaultMessage:
            'Your eligibility can not be confirmed, please reach out to your HR representative.',
        description:
            'Error message when the user cannot be confirmed as eligible.',
    },
    'registration.eligibility_step.form_error_count_plural': {
        id: 'registration.eligibility_step.form_error_count_plural',
        defaultMessage: 'There are {count} items that require your attention',
        description:
            'Validation message when there are multiple errors in the form.',
    },
    'registration.eligibility_step.form_error_count_singular': {
        id: 'registration.eligibility_step.form_error_count_singular',
        defaultMessage: 'There is 1 item that requires your attention',
        description: 'Validation message when there is one error in the form.',
    },
    'registration.eligibility_step.fields.required': {
        id: 'registration.eligibility_step.fields.required',
        defaultMessage: '{name} (Required)',
        description: 'Validation message when a field is required.',
    },
    'registration.eligibility_step.fields.date.error.invalid': {
        id: 'registration.eligibility_step.fields.date.error.invalid',
        defaultMessage: 'Error: A date is required',
        description: 'Validation message when a date is required.',
    },
    'registration.eligibility_step.fields.date-v2.error.invalid': {
        id: 'registration.eligibility_step.fields.date-v2.error.invalid',
        defaultMessage: 'Error: A {name} is required',
        description: 'Validation message when a date is required.',
    },
    'registration.eligibility_step.fields.email.error.invalid': {
        id: 'registration.eligibility_step.fields.email.error.invalid',
        defaultMessage: 'Error: An email address is required',
        description: 'Validation message when an email address is required.',
    },
    'registration.eligibility_step.fields.email.error.invalid_domain': {
        id: 'registration.eligibility_step.fields.email.error.invalid_domain',
        defaultMessage: 'Error: Enter an eligible email address',
        description:
            'Validation message when the email address is not from an eligible domain.',
    },
    eligibilityStepFieldSponsorCodeErrorInvalid: {
        id: 'registration.eligibility_step.fields.sponsor_code.error.invalid',
        defaultMessage: 'Your eligibility cannot be confirmed.',
        description:
            'Validation message when the email address is not from an eligible domain.',
    },
    'registration.eligibility_step.fields.phone.error.invalid': {
        id: 'registration.eligibility_step.fields.phone.error.invalid',
        defaultMessage: 'Error: A phone number is required',
        description: 'Validation message when a phone number is required.',
    },
    'registration.eligibility_step.fields.zip.error.invalid': {
        id: 'registration.eligibility_step.fields.zip.error.invalid',
        defaultMessage: 'Error: A ZIP code is required',
        description: 'Validation message when a ZIP code is required.',
    },
    'registration.eligibility_step.fields.integer.error.invalid': {
        id: 'registration.eligibility_step.fields.integer.error.invalid',
        defaultMessage: 'Error: {name} is required',
        description: 'Validation message when an integer is required.',
    },
    'registration.eligibility_step.fields.number.error.invalid': {
        id: 'registration.eligibility_step.fields.number.error.invalid',
        defaultMessage: 'Error: {name} is required',
        description: 'Validation message when a number is required.',
    },
    'registration.eligibility_step.fields.string.error.required': {
        id: 'registration.eligibility_step.fields.string.error.required',
        defaultMessage: 'Error: {name} is required',
        description: 'Validation message when a string is required.',
    },
    'registration.eligibility_not_confirmed.dialog_name': {
        id: 'registration.eligibility_not_confirmed.dialog_name',
        defaultMessage: 'Eligibility not confirmed dialog',
        description:
            'Dialog name for when the user’s eligibility is not confirmed.',
    },
    'registration.eligibility_not_confirmed.header': {
        id: 'registration.eligibility_not_confirmed.header',
        defaultMessage: 'Your eligibility has not been confirmed',
        description: 'Header for when the user’s eligibility is not confirmed.',
    },
    'registration.eligibility_not_confirmed.subheader': {
        id: 'registration.eligibility_not_confirmed.subheader',
        defaultMessage:
            'Please check your account details to make sure you have access to Calm Health.',
        description:
            'Message for when the user’s eligibility is not confirmed.',
    },
    'registration.join_sponsorship_failure.header': {
        id: 'registration.join_sponsorship_failure.header',
        defaultMessage:
            'We are unable to direct you to your Calm Health experience.',
        description: 'Error message when the call to join sponsorship fails.',
    },
    'registration.join_sponsorship_failure.subheader': {
        id: 'registration.join_sponsorship_failure.subheader',
        defaultMessage:
            'You already accessed Calm Health using a different Calm account. Please contact <SupportLink>support@calm.com</SupportLink> for assistance.',
        description:
            'Error message when the call to join sponsorship inicates the user has an existing account.',
    },
    'registration.success_step.eligibility_not_confirmed': {
        id: 'registration.success_step.eligibility_not_confirmed',
        defaultMessage: 'Your eligibility has not been confirmed',
        description:
            'Error message when the user’s eligibility is not confirmed.',
    },
    'registration.success_step.eligibility_instructions': {
        id: 'registration.success_step.eligibility_instructions',
        defaultMessage:
            'Reach out to your HR professional if you believe you have access to Calm Health to get your access code to unlock the full experience.',
        description: 'Instructions for the user to get an access code.',
    },
    'registration.success_step.email_sent': {
        id: 'registration.success_step.email_sent',
        defaultMessage: 'Email Sent',
        description:
            'Displayed to the user when the email was successfully sent.',
    },
    'registration.success_step.email_error': {
        id: 'registration.success_step.email_error',
        defaultMessage: 'Unable to send email',
        description: 'Displayed to the user when the email could not be sent.',
    },
    'registration.success_step.title': {
        id: 'registration.success_step.title',
        defaultMessage: 'Your registration has been successfully completed',
        description:
            'Displayed to the user when the registration is successful.',
    },
    'registration.success_step.title_converted': {
        id: 'registration.success_step.title_converted',
        defaultMessage: 'Your account has been converted',
        description:
            'Displayed to the user when the account is successfully converted.',
    },
    'registration.success_step.title_partial': {
        id: 'registration.success_step.title_partial',
        defaultMessage: 'Your registration has been completed',
        description:
            'Displayed to the user when the registration is successful, but there are still required actions.',
    },
    'registration.success_step.title_sponsor_updated': {
        id: 'registration.success_step.title_updated',
        defaultMessage: 'Your sponsor has been updated',
        description:
            'Displayed to the user when the sponsor is successfully updated.',
    },
    'registration.success_step.title_account_updated': {
        id: 'registration.success_step.title_account_updated',
        defaultMessage: 'Your account has been updated',
        description:
            'Displayed to a user that does not have a sponsorship when the account gains a sponsorship.',
    },
    'registration.success_step.verification_sent': {
        id: 'registration.success_step.verification_sent',
        defaultMessage: 'A verification email was sent to:',
        description:
            'Displayed to the user when the verification email is sent.',
    },
    'registration.success_step.verification_instructions': {
        id: 'registration.success_step.verification_instructions',
        defaultMessage:
            'Before you get started, we suggest you verify your email as it is required to access any Calm Health information or communications.{br}Tip: If you do not see the email, check your spam folder.',
        description: 'Instructions for the user to verify their email.',
    },
    'registration.success_step.resend_verification_email': {
        id: 'registration.success_step.resend_verification_email',
        defaultMessage: 'Resend Verification Email',
        description: 'Button to resend the verification email.',
    },
    'registration.no_access_code_dialog.title': {
        id: 'registration.no_access_code_dialog.title',
        defaultMessage: "Don't have an access code?",
        description:
            'Title for the dialog when the user does not have an access code.',
    },
    'registration.no_access_code_dialog.subtitle': {
        id: 'registration.no_access_code_dialog.subtitle',
        defaultMessage:
            'You can add an access code later from your profile screen. If you received an invite link to access Calm Health, try the link again.',
        description:
            'Description telling users they can still add an access code later.',
    },
    'registration.skip_access_code_dialog.title': {
        id: 'registration.skip_access_code_dialog.title',
        defaultMessage:
            'Are you sure you want to skip entering an access code?',
        description:
            'Confirmation prompt when a user tries to skip entering an access code.',
    },
    'registration.skip_access_code_dialog.subtitle': {
        id: 'registration.skip_access_code_dialog.subtitle',
        defaultMessage:
            'Using a valid access code enables the full Calm Health experience, which lets us customize the experience just for you.',
        description: 'Explanation of the benefits of entering an access code.',
    },
    'registration.skip_access_code_dialog.subtitle_v2': {
        id: 'registration.skip_access_code_dialog.subtitle_v2',
        defaultMessage:
            'Using a valid access code enables the full Calm Health experience.',
        description: 'Explanation of the benefits of entering an access code.',
    },
    'registration.skip_eligibility_dialog.title': {
        id: 'registration.skip_eligibility_dialog.title',
        defaultMessage:
            'Are you sure you want to skip verifying your eligibility?',
        description:
            'Confirmation prompt when a user tries to skip verifying their eligibility.',
    },
    'registration.skip_eligibility_dialog.subtitle': {
        id: 'registration.skip_eligibility_dialog.subtitle',
        defaultMessage:
            'Confirming your eligibility enables the full Calm Health experience',
        description: 'Explanation of the benefits of verifying eligibility.',
    },
    'registration.change_sponsorship_confirm.header': {
        id: 'registration.change_sponsorship_confirm.header',
        defaultMessage: 'Sponsor',
        description: 'Sponsor of a user subscription',
    },
    'registration.change_sponsorship_confirm.title': {
        id: 'registration.change_sponsorship_confirm.title',
        defaultMessage:
            'Would you like Calm Health to update your sponsor to {sponsor}?',
        description: 'Confirmation prompt to update the user’s sponsor.',
    },
    'registration.change_sponsorship_confirm.fnf_title': {
        id: 'registration.change_sponsorship_confirm.fnf_title',
        defaultMessage:
            'Do you want to update to a friends and family sponsorship? ',
        description:
            'Confirmation prompt to update the user’s sponsor to a friends and family sponsorship.',
    },
    'registration.change_sponsorship_confirm.eligible_until': {
        id: 'registration.change_sponsorship_confirm.eligible_until',
        defaultMessage: 'Eligible Until: {date}',
        description: 'End date for when the user’s eligibility ends.',
    },
    'registration.change_sponsorship_confirm.your_usage.p4': {
        id: 'registration.change_sponsorship_confirm.your_usage.p4',
        defaultMessage:
            "For more information, please review Calm Health's <FaqLink>FAQ</FaqLink> and <PrivacyPolicyLink>Privacy Policy</PrivacyPolicyLink>.",
        description:
            'Description of how usage information is shared with the sponsor.',
    },
    'registration.change_sponsorship_confirm.questions.title': {
        id: 'registration.change_sponsorship_confirm.questions.title',
        defaultMessage: 'Questions?',
        description:
            'Title for the section explaining how to get help with changing sponsorship.',
    },
    'registration.change_sponsorship_confirm.questions.description': {
        id: 'registration.change_sponsorship_confirm.questions.description',
        defaultMessage:
            'If you have questions or believe this could be an error, please contact your benefits administrator.',
        description:
            'Description of how to get help with changing sponsorship.',
    },
    'registration.change_sponsorship_confirm.questions.description_calmhealth':
        {
            id: 'registration.change_sponsorship_confirm.questions.description_calmhealth',
            defaultMessage:
                'You can also email Calm Health support and we can reach out to your plan sponsor to help solve the issue.',
            description:
                'Explanation of Calm Health can get involved in the change sponsorship process',
        },
    'registration.change_sponsorship_confirm.questions.description_fallback': {
        id: 'registration.change_sponsorship_confirm.questions.description_fallback',
        defaultMessage:
            'If you have questions or believe this could be an error, please contact your benefits administrator at {partnerName}, or email Calm Health support and we can reach out to your plan sponsor to help solve the issue.',
        description:
            'Explanation of Calm Health can get involved in the change sponsorship process',
    },
    'registration.change_sponsorship_confirm.questions.description_calmhealth_only':
        {
            id: 'registration.change_sponsorship_confirm.questions.description_calmhealth_only',
            defaultMessage:
                'If you have questions or believe this could be an error, please email Calm Health support.',
            description:
                'Description of how to get help with changing sponsorship, shown only on the Change of Sponsorship confirm screen, which does not show the outgoing sponsor support contacts.',
        },
    'registration.change_sponsorship_interstitial.title': {
        id: 'registration.change_sponsorship_interstitial.title',
        defaultMessage: 'Your account is being updated',
        description: 'Displayed to the user when the account is in progress.',
    },
    'registration.change_sponsorship_interstitial.subtitle': {
        id: 'registration.change_sponsorship_interstitial.subtitle',
        defaultMessage:
            "Your sponsorship update is in progress, and might take a few minutes.{br}Check back later for confirmation.{br}If you're having technical issues, contact support@calmhealth.com.",
        description:
            'Displayed to the user when the account update is in progress.',
    },
    'registration.hipaa.agreement_p1': {
        id: 'registration.hipaa.agreement_p1',
        defaultMessage:
            'Your health plan will not condition your treatment, payment, enrollment, or eligibility for benefits on whether you agree to this authorization.',
        description: 'Text of the HIPAA agreement.',
    },
    'registration.hipaa.agreement_p2': {
        id: 'registration.hipaa.agreement_p2',
        defaultMessage:
            'All HIPAA authorizations are required by law to inform you that your health information that is disclosed under this authorization may be re-disclosed by the recipient and no longer protected by federal privacy regulations.',
        description: 'Text of the HIPAA agreement.',
    },
    'registration.hipaa.agreement_p3': {
        id: 'registration.hipaa.agreement_p3',
        defaultMessage:
            'This authorization will expire upon the deletion of your account.',
        description: 'Text of the HIPAA agreement.',
    },
    'registration.hipaa.agreement_p4': {
        id: 'registration.hipaa.agreement_p4',
        defaultMessage:
            'You may revoke this authorization at any time by deleting your account. Revoking this authorization will not affect any actions that Calm took in reliance on the authorization before receiving your revocation.',
        description: 'Text of the HIPAA agreement.',
    },
    'registration.hipaa.agreement_title': {
        id: 'registration.hipaa.agreement_title',
        defaultMessage:
            'By agreeing to this authorization, you understand and agree:',
        description: 'Text of the HIPAA agreement.',
    },
    'registration.hipaa.header': {
        id: 'registration.hipaa.header',
        defaultMessage: 'Authorization',
        description: 'Header for the HIPAA authorization section.',
    },
    'registration.hipaa.input_error': {
        id: 'registration.hipaa.input_error',
        defaultMessage: 'Error: Your full name is required',
        description:
            'Validation message when the user does not provide their full name.',
    },
    'registration.hipaa.input_label': {
        id: 'registration.hipaa.input_label',
        defaultMessage: 'Full Name (Required)',
        description: 'Input label for the user’s full name.',
    },
    'registration.hipaa.pod_title': {
        id: 'registration.hipaa.pod_title',
        defaultMessage:
            'Authorization for use of protected health information.',
        description: 'Title for the HIPAA authorization section.',
    },
    'registration.hipaa.pod_subtitle': {
        id: 'registration.hipaa.pod_subtitle',
        defaultMessage:
            'By typing your name full name below and clicking "Continue", you authorize Calm.com, Inc. to retain and use your Calm Health information so that it can continue providing Calm Health to you after your health plan, provider or other sponsor has stopped offering Calm Health as a benefit to you.',
        description: 'Agreement for the HIPAA authorization section.',
    },
    'registration.hipaa.title': {
        id: 'registration.hipaa.title',
        defaultMessage: 'HIPAA Authorization',
        description: 'Title for the HIPAA authorization section.',
    },
    'registration.lost_sponsorship.additional_information': {
        id: 'registration.lost_sponsorship.additional_information',
        defaultMessage: 'Additional Information',
        description:
            'Header for the additional information section when the user has lost sponsorship.',
    },
    'registration.lost_sponsorship.convert_button': {
        id: 'registration.lost_sponsorship.convert_button',
        defaultMessage: 'Convert Account',
        description: 'Button to convert the user’s account.',
    },
    'registration.lost_sponsorship.new_sponsor': {
        id: 'registration.lost_sponsorship.new_sponsor',
        defaultMessage: 'Have a new sponsor?',
        description: 'Button to update the sponsor.',
    },
    'registration.lost_sponsorship.pod_title': {
        id: 'registration.lost_sponsorship.pod_title',
        defaultMessage: 'Would you like to convert your account?',
        description:
            'Title for the section when the user has lost sponsorship and converts to an unsponsored account.',
    },
    'registration.lost_sponsorship.pod_subtitle': {
        id: 'registration.lost_sponsorship.pod_subtitle',
        defaultMessage:
            'To retain partial access to the content you’ve been using on Calm Health, you can convert your account.',
        description: 'Prompt to convert the user’s account to unsponsored.',
    },
    'registration.lost_sponsorship.subtitle.date': {
        id: 'registration.lost_sponsorship.subtitle.date',
        defaultMessage: 'Your access through {partnerName} expired on {date}',
        description: 'Explanation of when the user’s sponsorship expired.',
    },
    'registration.lost_sponsorship.suspicious.title': {
        id: 'registration.lost_sponsorship.suspicious.title',
        defaultMessage: 'Your Calm Health sponsorship needs re-verification',
        description:
            'Title shown when a user whose account has been flagged as suspicious lands on the loss of sponsorship page.',
    },
    'registration.lost_sponsorship.suspicious.subtitle': {
        id: 'registration.lost_sponsorship.suspicious.subtitle',
        defaultMessage:
            'To keep your Calm Health access active, re-verify your sponsorship below, or contact your benefits provider if you think this is a mistake.',
        description:
            'Subtitle shown when a suspicious user needs to re-verify their sponsorship.',
    },
    'registration.lost_sponsorship.suspicious.reverify_button': {
        id: 'registration.lost_sponsorship.suspicious.reverify_button',
        defaultMessage: 'Re-verify sponsorship',
        description:
            'Button for a suspicious user to re-verify their sponsorship by entering an access code.',
    },
    'registration.lost_sponsorship.subtitle.no_date': {
        id: 'registration.lost_sponsorship.subtitle.no_date',
        defaultMessage: 'Your access through {partnerName} is no longer active',
        description:
            'Explanation that the user’s sponsorship is no longer active.',
    },
    'registration.lost_sponsorship.title': {
        id: 'registration.lost_sponsorship.title',
        defaultMessage: 'Your Calm Health Sponsorship has expired',
        description: 'Title for when the user has lost sponsorship.',
    },
    'registration.lost_sponsorship.enrolled_programs.item_label': {
        id: 'registration.lost_sponsorship.enrolled_programs.item_label',
        defaultMessage: 'Currently Enrolled Program',
        description: 'Title for the currently enrolled program section.',
    },
    'registration.lost_sponsorship.enrolled_programs.list_label': {
        id: 'registration.lost_sponsorship.enrolled_programs.list_label',
        defaultMessage: 'Currently Enrolled Programs',
        description: 'Label for the currently enrolled program section.',
    },
    'registration.lost_sponsorship.enrolled_programs.title_plural': {
        id: 'registration.lost_sponsorship.enrolled_programs.title_plural',
        defaultMessage: 'Complete your currently enrolled clinical programs',
        description:
            'Prompt to complete the user’s currently enrolled clinical programs.',
    },
    'registration.lost_sponsorship.enrolled_programs.title_singular': {
        id: 'registration.lost_sponsorship.enrolled_programs.title_singular',
        defaultMessage: 'Complete your currently enrolled clinical program',
        description:
            'Prompt to complete the user’s currently enrolled clinical programs.',
    },
    'registration.lost_sponsorship.enrolled_programs.subtitle': {
        id: 'registration.lost_sponsorship.enrolled_programs.subtitle',
        defaultMessage:
            'Convert your account to complete any currently enrolled clinic programs.',
        description:
            'Prompt to convert the user’s account to complete the currently enrolled clinical programs.',
    },
    'registration.lost_sponsorship.convert_title': {
        id: 'registration.lost_sponsorship.convert_title',
        defaultMessage: 'Your account is being converted',
        description:
            'Displayed to the user when the action to convert their account is in progress.',
    },
    'registration.lost_sponsorship.convert_subtitle': {
        id: 'registration.lost_sponsorship.convert_subtitle',
        defaultMessage:
            "Your account conversion is in progress, and might take a few minutes.{br}Check back later for confirmation.{br}If you're having technical issues, contact  support@calmhealth.com.",
        description:
            'Displayed to the user when the action to convert their account is in progress.',
    },
    'registration.lost_sponsorship.demo.description_1': {
        id: 'registration.lost_sponsorship.demo.description_1',
        defaultMessage:
            'Easily screen your populations for anxiety and depression',
        description:
            'Benefits of Calm Health for the sponsor demoing the application.',
    },
    'registration.lost_sponsorship.demo.description_2': {
        id: 'registration.lost_sponsorship.demo.description_2',
        defaultMessage:
            'Improve mental and physical health outcomes by providing access to enjoyable, evidence-based mental health content',
        description:
            'Benefits of Calm Health for the sponsor demoing the application.',
    },
    'registration.lost_sponsorship.demo.description_3': {
        id: 'registration.lost_sponsorship.demo.description_3',
        defaultMessage: 'Direct members to the right level of care',
        description:
            'Benefits of Calm Health for the sponsor demoing the application.',
    },
    'registration.lost_sponsorship.demo.extend': {
        id: 'registration.lost_sponsorship.demo.extend',
        defaultMessage: 'To extend access or for more information contact:',
        description: 'Cta for the sponsor demoing the application.',
    },
    'registration.lost_sponsorship.demo.title': {
        id: 'registration.lost_sponsorship.demo.title',
        defaultMessage: 'Your trial account has expired',
        description: 'Explanation that the demo account has expired',
    },
    'registration.lost_sponsorship.demo.subtitle': {
        id: 'registration.lost_sponsorship.demo.subtitle',
        defaultMessage:
            "Don't worry, you can still unlock all the benefits of Calm Health!",
        description: 'Explanation that the demo account has expired',
    },
});

export default registrationMessages;
